import { axiosPublic } from "../../api/axios";

const trackVisitor = async (visitorData) => {
  const response = await axiosPublic.post(`/visitor/track`, visitorData);
  return response.data;
};

const visitorService = {
  trackVisitor,
};

export default visitorService;
